import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import cn from 'classnames'
import Tag, { TagProps } from './Tag'

const useStyles = makeStyles(() => ({
  wrap: {
    whiteSpace: 'normal',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  expanded: {
    minWidth: '244px',
    paddingTop: '12px',
    paddingBottom: '12px',
  },
  link: {
    color: '#0F5DB5',
    textDecoration: 'none',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
  },
}))

interface TagsProps {
  tags: TagProps[]
  expandable?: boolean
  maxTags?: number
}

export default function Tags({ tags, expandable = false, maxTags = 3 }: TagsProps) {
  const classes = useStyles()
  const canExpand = expandable && tags.length > maxTags
  const [expanded, setExpanded] = useState<boolean>(false)
  const displayTags = canExpand && !expanded ? tags.slice(0, maxTags) : tags

  const gridContent = (
    <Grid container direction="row" alignItems="flex-start" spacing={1}>
      {displayTags.map(props => (
        <Grid item key={props.id}>
          <Tag {...props} />
        </Grid>
      ))}
      {canExpand && (
        <Grid item>
          {expanded ? (
            <button type="button" className={classes.link} onClick={() => setExpanded(false)}>
              (show less)
            </button>
          ) : (
            <button type="button" className={classes.link} onClick={() => setExpanded(true)}>
              (show more)
            </button>
          )}
        </Grid>
      )}
    </Grid>
  )

  if (!expandable) {
    return gridContent
  }

  return (
    <div
      className={cn({
        [classes.wrap]: expanded,
        [classes.noWrap]: !expanded,
        [classes.expanded]: expanded,
      })}
    >
      {gridContent}
    </div>
  )
}
